import { createSelector } from "@reduxjs/toolkit";
import { IState } from "../../Model/State/IState";
import { selectSelectedOrActiveProjectIds, selectSelectedOrActiveProjects } from "./Projects";
import { selectIsDetailsOpen } from "./UI";

export function selectShowExportDialog(state: IState): boolean {
  return state.export.showDialog;
}

export const selectExportIndex = createSelector(
  (state: IState) => selectIsDetailsOpen(state),
  (state: IState) => state.export.exportIndex,
  (isDetailsOpen, exportIndex) => (isDetailsOpen ? 0 : exportIndex)
);

export const selectExportingProject = createSelector(
  (state: IState) => selectExportIndex(state),
  (state: IState) => selectSelectedOrActiveProjects(state),
  (exportIndex, selectedProjects) => selectedProjects[exportIndex]
);

export const selectExportingProjectId = createSelector(
  (state: IState) => selectExportIndex(state),
  (state: IState) => selectSelectedOrActiveProjectIds(state),
  (exportIndex, selectedProjectIds) => selectedProjectIds[exportIndex]
);
